export function matchesIndexQuery(searchText: string, query: string): boolean {
  const words = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  return words.every((word) => searchText.includes(word));
}
